import * as amplitude from '@amplitude/analytics-browser'
import { plugin as engagementPlugin } from '@amplitude/engagement-browser'

import { isDev } from '../config'
import { AMPLITUDE_API_KEY } from '../keys'

let isInitialized = false

export const initAmplitude = () => {
  if (!AMPLITUDE_API_KEY || isInitialized || isDev) return

  amplitude.init(AMPLITUDE_API_KEY, {
    serverZone: 'EU',
    fetchRemoteConfig: false,
    autocapture: {
      pageViews: true,
      sessions: true,
      formInteractions: true,
      fileDownloads: true,
    },
  })

  amplitude.add(
    engagementPlugin({
      serverZone: 'EU',
      serverUrl: 'https://dharma.capturi.ai',
      cdnUrl: 'https://dharma.capturi.ai/engagement-cdn',
      mediaUrl: 'https://dharma.capturi.ai/engagement-media',
    }),
  )

  isInitialized = true
}

export const trackAmplitudeEvent = (
  eventName: string,
  properties: Record<string, string | number | boolean>,
) => {
  if (!isInitialized || isDev) return

  amplitude.track(eventName, properties)
}

export const setAmplitudeUserId = (userId: string) => {
  if (!isInitialized || isDev) return

  amplitude.setUserId(userId)
}
